import { component } from "picoapp";
import { str2json } from "@utils";
import React, { useState, useEffect } from "react"
import { createRoot } from "react-dom/client"
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";



import './component.scss';

gsap.registerPlugin(ScrollTrigger);


function Features({node, ctx}) {
  const [isSelected, setIsSelected] = useState(0)
  const blocks = str2json(node.attributes[0].value)

  useEffect(() => {
    gsap.to(".Features", {
      scrollTrigger: {
        trigger: ".Features",
        start: "top 100%",
        end: "bottom top",
        onEnter: () => {
          handleClick(0)
          console.log("enter")
        },
        onEnterBack: () => {
          handleClick(0)
          console.log("enter-back")
        }
      },
    });
  }, []);

  useEffect(()=> {
    gsap.fromTo(".Feature__image.is-selected", {
      opacity: 0
    }, { opacity: 1 })
    const timer = setTimeout(() => {
      if (isSelected + 2 <= blocks.length) {
        setIsSelected(isSelected + 1)
      }
      else {
        setIsSelected(0)
      }
    }, 7500);
    return () => clearTimeout(timer);
  }, [isSelected])

  const handleClick = (i) => {
    setIsSelected(i);
  }
  return (
    <>
    {blocks.length &&
      <div className="Features page-width">
        <div className="Feature__images"> 
        {blocks.map((block, i) => 
          (<div key={`Feature__image--${i}`} className={`Feature__image ${isSelected == i && 'is-selected'}`}>
            <img src={block.image}/>
          </div>)
        )}
        </div> 
        <div className="Feature__nav"> 
        {blocks.map((block,i) => 
          (<div key={`Feature__text--${i}`} onClick={()=> handleClick(i)} className={`Feature__text ${isSelected == i && 'is-selected'}`}>
            <div className="border-top"></div>
            <div className="Feature__text-text">
              <div className="Feature__title">{block.title}</div>
              <div className="Feature__description">{block.desc}</div>
            </div>
          </div>)
        )}
        </div> 
      </div>
    }
    </>
  )
}

// module.exports = Slider;
export default component((node, ctx) => {
  const element = <Features node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});

